import { render, staticRenderFns } from "./DropdownAction.vue?vue&type=template&id=477c523d"
import script from "./DropdownAction.vue?vue&type=script&lang=js"
export * from "./DropdownAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports